import React, { useState } from 'react';
import cn from 'classnames';
import BulkUnlinkTab from './elements/BulkUnlinkTab';
import BulkLinkTab from './elements/BulkLinkTab';
import CatalogToolSubNav from './CatalogToolSubNav';
import { getUrlParam, setUrlParam, deleteUrlParam } from '../../helpers/helpers';
import './CatalogTool.scss';

const TABS = [
  { id: 'unlink', label: 'Bulk Unlink' },
  { id: 'link', label: 'Bulk Link' }
];

const readTabFromUrl = () => (getUrlParam('tab') === 'link' ? 'link' : 'unlink');
const writeTabToUrl = tab => (tab === 'link' ? setUrlParam('tab', 'link') : deleteUrlParam('tab'));

/** Tabbed admin tool for bulk catalog operations: Bulk Unlink (destructive, dark) and Bulk Link (additive, green). */
const CatalogTool = () => {
  const [activeTab, setActiveTab] = useState(readTabFromUrl);

  const selectTab = tab => {
    setActiveTab(tab);
    writeTabToUrl(tab);
  };

  return (
    <div className={cn('catalog-tool-container', activeTab === 'link' ? 'mode-link' : 'mode-unlink')}>
      <CatalogToolSubNav />
      <header className='catalog-tool-header'>
        <h1>Catalog Tool</h1>
        <nav className='ct-tabs' role='tablist' aria-label='Catalog tool modes'>
          {TABS.map(tab => (
            <button
              key={tab.id}
              type='button'
              role='tab'
              aria-selected={activeTab === tab.id}
              className={cn('ct-tab', tab.id, { active: activeTab === tab.id })}
              onClick={() => selectTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </nav>
      </header>

      {/* Both tabs stay mounted so pasted URLs and confirmed scopes survive tab switches. */}
      <div className={cn('ct-tab-panel', { hidden: activeTab !== 'unlink' })}>
        <BulkUnlinkTab />
      </div>
      <div className={cn('ct-tab-panel', { hidden: activeTab !== 'link' })}>
        <BulkLinkTab />
      </div>
    </div>
  );
};

export default CatalogTool;
